// @flow
import CardBoutique from 'components/fragments/card/CardBoutique';
import { connect } from 'react-redux';

import type { StateType } from 'types/Actions';
import type { StateProps} from 'components/fragments/card/CardBoutique';

export default connect(
  (state: StateType): StateProps => ({
    boutique: state.settingsState.boutique,
    userPref: state.userState.userPref
  })
)(CardBoutique);
